//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 图片较大，无法直接引用
import errorMsgImg from '../../image/errorMsg.png';

export default {
    name: 'error-msg',
    data() {
        return {
            errorMsgImg: errorMsgImg
        }
    },
    methods: {
        exitLogin() {
            this.$x.userInfo.eid = '';
            this.$x.post('../AppLogout.aspx').finally(t => {
                this.$x.axios.doLogin(true)
            })
        },
    },
    components: {}
}
